import styled from '@emotion/styled';
import {
  Button,
  ClickAwayListener,
  Divider,
  IconButton,
  List as _List,
  ListItem,
  ListItemIcon as _ListItemIcon,
  ListItemText,
  ListSubheader as _ListSubheader,
  Paper,
  Popper,
  Typography,
  withStyles,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import OpenInNew from '@material-ui/icons/OpenInNew';
import { createElement, FC, Fragment, MouseEvent, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import Config from '../../../../core/Config';
import AcctAccount, { PermissionAction as AcctPermissionAction } from '../../../../entity/AcctAccount';
import Agent from '../../../../entity/Agent';
import BfOrganization, { PermissionAction as BfPermissionAction } from '../../../../entity/BfOrganization';
import Membership from '../../../../entity/Membership';
import Organization, { PermissionAction } from '../../../../entity/Organization';
import {
  COLOR_BORDER_PRIMARY,
  COLOR_MENU_BACKGROUND,
  COLOR_MENU_HEADER,
  COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
  COLOR_SIDEMENU_CONTENT_SELECTED,
  COLOR_TEXT_MAIN,
} from '../../../constant/color';
import { SPACING_REGULAR } from '../../../constant/spacing';
import { context as ConfigContext } from '../../../context/config';
import Spinner from '../../compound/Spinner';
import AccountConsoleIcon from '../../primitive/Icons/AccountConsoleIcon';
import EngineIcon from '../../primitive/Icons/EngineIcon';
import SalesIcon from '../../primitive/Icons/SalesIcon';
import VideoIcon from '../../primitive/Icons/VideoIcon';
// import KaizenLogo from '../../primitive/Icons/KaizenLogo';
import _KaizenPlatformLogo from '../../primitive/KaizenPlatformLogo';
import { HEADBAR_HEIGHT } from '../HeadBar';
import { LINK_MENU_WIDTH } from './ServiceContents';

export const MENU_WIDTH = 240;
export const SUBTITLE_HEIGHT = 32;

export const MENU_ITEMS = [
  'home',
  'user_setting/general',
  'user_setting/profile',
  'user_setting/login',
  'user_setting/personal',
  'user_setting/payment',
  'account_setting/new',
  'organization_setting/account',
  'organization_setting/general',
  'organization_setting/members',
  'agent_setting/members',
  'account_setting/payments',
  'account_setting/points',
];

interface Props {
  selected: string;
  onSelectMenu: (item: string) => void;
  profileUrl: string;
  organizations: Organization[] | null;
  setCurrentOrgOrAccount: (organization: Organization) => void;
  currentOrgOrAccount: Organization | null;
  currentAccount: Organization | null;
  currentOrganization: Organization | null;
  currentAcctAccount: AcctAccount | null;
  currentAcctAccountLoading: boolean;
  currentBfOrganization: BfOrganization | null;
  currentBfOrganizationLoading: boolean;
  isSmartPhone?: boolean;
  currentUserId: string;
  memberships?: Membership[];
  currentAgent: Agent | null;
}

const DrawerContents: FC<Props> = ({
  onSelectMenu,
  profileUrl,
  organizations,
  currentOrgOrAccount,
  currentAccount,
  currentOrganization,
  currentAcctAccount,
  currentAcctAccountLoading,
  currentBfOrganization,
  currentBfOrganizationLoading,
  isSmartPhone,
  currentAgent,
  // currentUserId,
  // memberships,
}) => {
  const pathName = useLocation().pathname;
  const config = useContext(ConfigContext);

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onClickMenu = (e: MouseEvent<HTMLElement>) => {
    setOpen(true);
    setAnchorEl(e.currentTarget);
  };

  const onRequestClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <NavContainer>
        {drawer(
          onSelectMenu,
          pathName,
          profileUrl,
          organizations,
          currentOrgOrAccount,
          currentAccount,
          currentOrganization,
          currentAcctAccount,
          currentAcctAccountLoading,
          currentBfOrganization,
          currentBfOrganizationLoading,
          config,
          open,
          anchorEl,
          onClickMenu,
          onRequestClose,
          currentAgent,
          isSmartPhone,
        )}
      </NavContainer>
    </Fragment>
  );
};

const drawer = (
  onSelectMenu: (item: string) => void,
  pathName: string,
  profileUrl: string,
  organizations: Organization[] | null,
  currentOrgOrAccount: Organization | null,
  currentAccount: Organization | null,
  currentOrganization: Organization | null,
  currentAcctAccount: AcctAccount | null,
  currentAcctAccountLoading: boolean,
  currentBfOrganization: BfOrganization | null,
  currentBfOrganizationLoading: boolean,
  config: Config,
  open: boolean,
  anchorEl: HTMLElement | null,
  onClickMenu: (e: MouseEvent<HTMLElement>) => void,
  onRequestClose: () => void,
  currentAgent: Agent | null,
  // currentUserId: string,
  isSmartPhone?: boolean,
  // memberships?: Membership[],
) => {
  const accounts = organizations && organizations.filter(o => o.isAccount());
  // const membership = memberships?.find(membership => membership.user.id === currentUserId);
  const agentPermission = currentAgent && currentAgent?.id && currentAgent.permissions[0] ? true : false;
  const agentMembershipsWrite = currentAgent?.permissions?.find(p => p.action === 'INVITATIONS_WRITE')?.permission;
  const agentInvitationWrite = currentAgent?.permissions?.find(p => p.action === 'MEMBERSHIPS_WRITE')?.permission;

  return (
    <div style={{ width: isSmartPhone ? '100%' : MENU_WIDTH, marginLeft: isSmartPhone ? undefined : LINK_MENU_WIDTH }}>
      {isSmartPhone ? <div style={{ height: 64 }} /> : null}
      {isSmartPhone ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'flex-start',
            alignItems: 'flex-start',
            height: 120,
            background: '#F0F1F2',
            padding: 24,
          }}
        >
          <Typography
            style={{
              color: COLOR_TEXT_MAIN,
              fontSize: 12,
              fontWeight: 700,
              marginBottom: 12,
            }}
          >
            <FormattedMessage id="menu.services" />
          </Typography>
          <ServiceSelectButton onClick={onClickMenu}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <AccountConsoleIcon />
              <Typography
                style={{
                  color: COLOR_TEXT_MAIN,
                  fontSize: 14,
                  fontWeight: 700,
                  marginLeft: 8,
                }}
              >
                {/* TODO:jp,usの言語切り替え実施 */}
                Account Console
              </Typography>
            </div>
            <ArrowDropDownIcon style={{ color: COLOR_TEXT_MAIN }} />
          </ServiceSelectButton>
        </div>
      ) : null}
      <List style={{ padding: isSmartPhone ? '0px 24px' : '0px 16px' }}>
        <ListItem
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: isSmartPhone ? 14 : HEADBAR_HEIGHT + 24,
            flex: 'none',
          }}
        />
        {MenuItem(onSelectMenu, pathName, 'home', isSmartPhone)}
        <StyledDivider />
        <ListItem
          style={{
            height: SUBTITLE_HEIGHT,
          }}
        >
          <SubTitle>
            <FormattedMessage id="menu.subheader.kaizen_id_settings" />
          </SubTitle>
        </ListItem>
        {MenuItem(onSelectMenu, pathName, 'user_setting/general', isSmartPhone)}
        {SubMenuItem(onSelectMenu, pathName, 'user_setting/profile', profileUrl)}
        {MenuItem(onSelectMenu, pathName, 'user_setting/login', isSmartPhone)}
        {MenuItem(onSelectMenu, pathName, 'user_setting/personal', isSmartPhone)}
        {MenuItem(onSelectMenu, pathName, 'user_setting/payment', isSmartPhone)}

        {agentPermission ? (
          <Fragment>
            <StyledDivider />
            <ListItem
              style={{
                height: SUBTITLE_HEIGHT,
              }}
            >
              <SubTitle>
                <FormattedMessage id="menu.subheader.agent_settings" />
              </SubTitle>
            </ListItem>
          </Fragment>
        ) : null}
        {agentPermission ? MenuItem(onSelectMenu, pathName, `agent_setting/members`, isSmartPhone) : null}
        {agentMembershipsWrite && agentInvitationWrite
          ? MenuItem(onSelectMenu, pathName, `agent_setting/payments`, isSmartPhone)
          : null}

        {(currentOrganization || accounts || currentAccount || currentOrgOrAccount) && (
          <Fragment>
            <StyledDivider />
            <ListItem
              style={{
                height: SUBTITLE_HEIGHT,
              }}
            >
              <SubTitle>
                <FormattedMessage id="menu.subheader.organization_settings" />
              </SubTitle>
            </ListItem>
          </Fragment>
        )}
        {accounts && accounts.length == 0 && organizations && organizations.length == 0
          ? MenuItem(onSelectMenu, pathName, 'account_setting/new', isSmartPhone)
          : null}
        {currentAccount && currentOrgOrAccount && currentAccount.hasPermission(PermissionAction.ORGANIZATIONS_READ)
          ? MenuItem(onSelectMenu, pathName, `organization_setting/${currentOrgOrAccount.id}/account`, isSmartPhone)
          : null}
        {!currentAccount &&
        currentOrganization &&
        currentOrgOrAccount &&
        currentOrganization.hasPermission(PermissionAction.ORGANIZATIONS_READ)
          ? MenuItem(onSelectMenu, pathName, `organization_setting/${currentOrgOrAccount.id}/general`, isSmartPhone)
          : null}
        {currentAcctAccountLoading || currentBfOrganizationLoading ? (
          <ListItem>
            <ListItemText>
              <Spinner />
            </ListItemText>
          </ListItem>
        ) : null}
        {!currentAcctAccountLoading &&
        currentOrgOrAccount &&
        currentAcctAccount &&
        currentAcctAccount.hasPermission(AcctPermissionAction.UPDATE_KAIZEN_USER_CREDIT_CARD)
          ? MenuItem(onSelectMenu, pathName, `account_setting/${currentOrgOrAccount.id}/payments`, isSmartPhone)
          : null}
        {!currentAcctAccountLoading &&
        !currentBfOrganizationLoading &&
        currentOrgOrAccount &&
        ((currentAcctAccount &&
          currentAcctAccount.hasPermission(AcctPermissionAction.UPDATE_KAIZEN_USER_CREDIT_CARD) &&
          currentAcctAccount.hasPermission(AcctPermissionAction.POINT_AVAILABLE_REGION)) ||
          (currentBfOrganization && currentBfOrganization.hasPermission(BfPermissionAction.SHOW_POINT_TRANSACTIONS)))
          ? MenuItem(onSelectMenu, pathName, `account_setting/${currentOrgOrAccount.id}/points`, isSmartPhone)
          : null}

        {/* hidden for member, hidden for business acct  */}
        {!currentAcctAccountLoading &&
        !currentBfOrganizationLoading &&
        currentOrganization &&
        !currentOrganization.isAccount() &&
        currentBfOrganization &&
        currentBfOrganization.hasPermission(BfPermissionAction.SHOW_KAIZEN_MARKET)
          ? MenuItem(onSelectMenu, pathName, `organizations/${currentOrganization.id}/product_list`, isSmartPhone)
          : null}
        {currentOrganization && currentOrganization.hasPermission(PermissionAction.ORGANIZATIONS_WRITE)
          ? MenuItem(onSelectMenu, pathName, `organization_setting/${currentOrganization.id}/members`, isSmartPhone)
          : null}
      </List>

      <Popper open={open} anchorEl={anchorEl} placement="bottom-end" transition disablePortal>
        <StyledPaper style={{ width: 280, backgroundColor: COLOR_MENU_BACKGROUND }}>
          <ClickAwayListener onClickAway={onRequestClose}>
            <List
              style={{
                padding: 0,
              }}
            >
              <ListItem
                style={{
                  height: 48,
                  display: 'flex',
                  justifyContent: 'space-between',
                  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
                  backgroundColor: COLOR_MENU_HEADER,
                }}
              >
                <Typography
                  variant="body1"
                  style={{
                    position: 'static',
                    fontSize: 16,
                    fontWeight: 700,
                    color: COLOR_TEXT_MAIN,
                  }}
                >
                  <FormattedMessage id="menu.services" />
                </Typography>
                <IconButton onClick={onRequestClose} style={{ width: 28, height: 28 }}>
                  <CloseIcon style={{ color: COLOR_TEXT_MAIN, width: 24, height: 24 }} />
                </IconButton>
              </ListItem>
              <List
                style={{
                  padding: '16px 0px 24px 0px',
                }}
              >
                <ListItem>
                  <Button
                    href={config.SALES_URL}
                    target="_blank"
                    style={{
                      width: '100%',
                      padding: '10px 16px',
                      borderRadius: 8,
                      display: 'flex',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <SalesIcon />
                    <Typography
                      style={{
                        color: COLOR_TEXT_MAIN,
                        fontSize: 14,
                        fontWeight: 700,
                        marginLeft: 12,
                      }}
                    >
                      <FormattedMessage id="menu.video_application" />
                    </Typography>
                  </Button>
                </ListItem>
                <ListItem>
                  <Button
                    href={config.SITE_DASHBOARD_URL}
                    target="_blank"
                    style={{
                      width: '100%',
                      padding: '10px 16px',
                      borderRadius: 8,
                      display: 'flex',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <EngineIcon />
                    <Typography
                      style={{
                        color: COLOR_TEXT_MAIN,
                        fontSize: 14,
                        fontWeight: 700,
                        marginLeft: 12,
                      }}
                    >
                      <FormattedMessage id="menu.web_optimization" />
                    </Typography>
                  </Button>
                </ListItem>
                <ListItem>
                  <Button
                    href={config.AD_DASHBOARD_URL}
                    target="_blank"
                    style={{
                      width: '100%',
                      padding: '10px 16px',
                      borderRadius: 8,
                      display: 'flex',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <VideoIcon />
                    <Typography
                      style={{
                        color: COLOR_TEXT_MAIN,
                        fontSize: 14,
                        fontWeight: 700,
                        marginLeft: 12,
                      }}
                    >
                      <FormattedMessage id="menu.video_production" />
                    </Typography>
                  </Button>
                </ListItem>
              </List>
            </List>
          </ClickAwayListener>
        </StyledPaper>
      </Popper>
    </div>
  );
};

const MenuItem = (onSelectMenu: (item: string) => void, selected: string, item: string, isSmartPhone?: boolean) => {
  const itemId = item.replace(/\/[0-9]+/, '');
  const msgId = `menu.items.${itemId}`;
  return (
    <ListItem
      key={item}
      style={{
        height: LIST_ITEM_HEIGHT,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: 'none',
        margin: '0px 0px',
        padding: '0px',
      }}
    >
      <Button
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          padding: '13px 16px',
          textAlign: 'start',
          borderRadius: 8,
          backgroundColor: selected !== `/${item}` ? undefined : COLOR_SIDEMENU_CONTENT_SELECTED,
        }}
        onClick={_ => onSelectMenu(item)}
      >
        <StyleMenuItemText>
          <FormattedMessage id={msgId} />
        </StyleMenuItemText>
        {isSmartPhone ? <NavigateNextIcon style={{ color: COLOR_TEXT_MAIN }} /> : null}
      </Button>
    </ListItem>
  );
};

const SubMenuItem = (_: (item: string) => void, __: string, item: string, url: string) => {
  const msgId = `menu.items.${item}`;
  return (
    <ListItem
      key={item}
      style={{
        height: LIST_ITEM_HEIGHT,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: 'none',
        margin: '0px 0px',
        padding: '0px',
      }}
    >
      <Button
        href={url}
        target="_blank"
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          padding: '13px 16px',
          textAlign: 'start',
          borderRadius: 8,
        }}
      >
        <StyleMenuItemText>
          <FormattedMessage id={msgId} />
        </StyleMenuItemText>
        <ListItemIcon style={nestedStyle.icon}>
          <OpenInNew fontSize="inherit" />
        </ListItemIcon>
      </Button>
    </ListItem>
  );
};

const NavContainer = styled('div')([
  {
    margin: '0',
    width: `${MENU_WIDTH + LINK_MENU_WIDTH}px`,
    height: '100%',
    outline: 'none',
    borderRight: `solid 1px ${COLOR_BORDER_PRIMARY}`,
  },
  {
    '@media (max-width: 1024px)': {
      width: `100%`,
    },
  },
]);

const LIST_ITEM_HEIGHT = 40;

const nestedStyle = {
  icon: {
    marginRight: 0,
    fontSize: '20px',
    color: COLOR_TEXT_MAIN,
    justifyContent: 'flex-end',
  },
};

const SubTitle = withStyles({
  root: {
    /* ゴール設定 */
    position: 'static',
    width: '232px',
    height: '12px',
    left: '32px',
    top: '16px',

    /* Font / 14px / W7 / 100% */
    fontFamily: 'Hiragino Sans',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 12,
    lineHeight: '100%',
    /* identical to box height, or 14px */

    /* Color / Black */
    color: '#CACACA',

    /* Inside Auto Layout */
    flex: 'none',
    order: 0,
    flexGrow: 1,
  },
})(Typography);

const StyleMenuItemText = withStyles({
  root: {
    /* ゴール設定 */
    position: 'static',
    height: '14px',
    left: '32px',
    top: '16px',

    /* Font / 14px / W7 / 100% */
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '100%',

    /* Color / Black */
    color: COLOR_TEXT_MAIN,

    /* Inside Auto Layout */
    flex: 'none',
    order: 0,
    flexGrow: 1,
  },
})(Typography);

const StyledDivider = withStyles({
  root: {
    width: '100%',
    margin: '8px 0px',
    backgroundColor: 'transparent',
  },
})(Divider);

const ServiceSelectButton = withStyles({
  root: {
    width: '100%',
    background: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
    border: `1px solid ${COLOR_BORDER_PRIMARY}`,
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '6px 16px',
  },
})(Button);

const StyledPaper = withStyles({
  rounded: {
    borderRadius: 0,
  },
  elevation1: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
  },
})(Paper);

const List = styled(_List)({
  marginBottom: SPACING_REGULAR,
}) as typeof _List;

const ListItemIcon = styled(_ListItemIcon)({
  marginRight: 0,
}) as typeof _ListItemIcon;

export default DrawerContents;
